import React from 'react'
import Section from '../components/Section'
import Dropdown from 'react-bootstrap/Dropdown'
import WageLabelModal from '../components/Modals/WageLabel'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

class Product extends React.Component {
	showLabelModal = e => {
		let modalEl = document.querySelector('#wage-label__modal')

		modalEl.classList.add('show')
	}

	closeLabelModal = e => {
		let modalEl = document.querySelector('#wage-label__modal')

		modalEl.classList.remove('show')
	}

	toggleDropdown = e => {
		e.currentTarget.classList.toggle('active')
	}

	toggleSize = e => {
		const sizeToSelect = e.currentTarget
		const sizesArr = Array.from(document.querySelectorAll('.size'))

		sizesArr.forEach(size => {
			size.classList.remove('active')
		})
		sizeToSelect.classList.add('active')
	}
	render() {
		return (
			<div className='main-container'>
				<Section id='product__section'>
					<div className='col-md-8'>
						<nav aria-label='breadcrumb'>
							<ol className='breadcrumb'>
								<li className='breadcrumb-item'>
									<a href='/'>Home</a>
								</li>
								<li
									className='breadcrumb-item '
									aria-current='page'>
									<a href='/category'>Women</a>
								</li>
								<li
									className='breadcrumb-item '
									aria-current='page'>
									<a href='/category/subcategory'>Tops</a>
								</li>
								<li
									className='breadcrumb-item active'
									aria-current='page'>
									Product
								</li>
							</ol>
						</nav>
						<div className='row'>
							<div className='col-md-2'>
								<ul>
									<li className='product-image__thumbnail active'>
										<img
											src='https://placehold.it/120x180'
											alt='placholder'
										/>
									</li>
									<li className='product-image__thumbnail'>
										<img
											src='https://placehold.it/120x180'
											alt='placeholder'
										/>
									</li>
									<li className='product-image__thumbnail'>
										<img
											src='https://placehold.it/120x180'
											alt='placeholder'
										/>
									</li>
								</ul>
							</div>
							<div className='col-md-10'>
								<img
									src='https://placehold.it/600x750'
									alt='placeholder'
								/>
							</div>
						</div>
					</div>
					<div className='col-md-4'>
						<h4>The Etho Floral in December Print Blouse</h4>
						<a href='/brand-directory/brand'>
							Brand Name&nbsp;
							<FAI icon='chevron-right' />
						</a>
						<p className='semi-bold'>$49.99</p>
						<hr />
						<h4>Choose a Size:</h4>
						<ul className='sizes'>
							<li
								className='size active'
								onClick={this.toggleSize}>
								xs
							</li>
							<li className='size' onClick={this.toggleSize}>
								sm
							</li>
							<li className='size' onClick={this.toggleSize}>
								md
							</li>
							<li className='size' onClick={this.toggleSize}>
								lg
							</li>
							<li className='size' onClick={this.toggleSize}>
								xl
							</li>
						</ul>
						<hr />
						<Dropdown
							onSelect={(key, e) => {
								document.querySelector(
									'#color-dropdown'
								).innerText = e.currentTarget.innerText
							}}>
							<Dropdown.Toggle variant='' id='color-dropdown'>
								Select Color
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<Dropdown.Item>Maroon</Dropdown.Item>
								<Dropdown.Item>Pink</Dropdown.Item>
								<Dropdown.Item>Black</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
						<hr />
						<ul>
							<li>
								<span onClick={this.toggleDropdown}>
									Details
								</span>
								<span className='plus-symbol' />
								<div className='expandable-el'>
									<p>
										Lorem ipsum dolor sit amet consectetur
										adipisicing elit. Non reprehenderit,
										dicta eligendi est praesentium sequi
										facilis! Deserunt, expedita facilis?
										Maiores?
									</p>
								</div>
							</li>
							<li>
								<span onClick={this.toggleDropdown}>
									Seller Story
								</span>
								<span className='plus-symbol' />
								<div className='expandable-el'>
									<p>
										Lorem ipsum dolor sit amet consectetur
										adipisicing elit. Quaerat dolore nobis
										delectus libero quas ullam amet non
										recusandae ut vitae.
									</p>
								</div>
							</li>
							<li>
								<span onClick={this.toggleDropdown}>
									Shipping &amp; Returns
								</span>
								<span className='plus-symbol' />
								<div className='expandable-el'>
									<p>
										Lorem ipsum dolor sit amet consectetur
										adipisicing elit. Est, magnam. Enim vel
										reprehenderit, nostrum obcaecati illo
										modi, unde perferendis velit voluptatum,
										ut itaque blanditiis temporibus
										doloremque iure maxime dolorem.
										Quibusdam?
									</p>
								</div>
							</li>
						</ul>
						<hr />
						<span className='btn btn--primary'>
							<span className='btn__text'>Add To Cart</span>
						</span>
						<span
							className='btn btn--secondary'
							onClick={this.showLabelModal}>
							<span className='btn__text'>See Values Label</span>
						</span>
					</div>
				</Section>
				<Section id='style-with__section'>
					<div className='col-12 text-center'>
						<h3>Style With</h3>
					</div>
					<div className='col-md-3'>
						<a
							href='/category/subcategory/product'
							className='card'>
							<div className='card-img-top'>
								<img
									src='https://placehold.it/300'
									alt='placeholder'
								/>
							</div>
							<div className='card-body'>
								<h4 className='card-title'>Lorem Ipsum</h4>
								<p className='card-text'>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Omnis maiores sed sunt,
									iusto consectetur a!
								</p>
							</div>
						</a>
					</div>
					<div className='col-md-3'>
						<a
							href='/category/subcategory/product'
							className='card'>
							<div className='card-img-top'>
								<img
									src='https://placehold.it/300'
									alt='placeholder'
								/>
							</div>
							<div className='card-body'>
								<h4 className='card-title'>Lorem Ipsum</h4>
								<p className='card-text'>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Omnis maiores sed sunt,
									iusto consectetur a!
								</p>
							</div>
						</a>
					</div>
					<div className='col-md-3'>
						<a
							href='/category/subcategory/product'
							className='card'>
							<div className='card-img-top'>
								<img
									src='https://placehold.it/300'
									alt='placeholder'
								/>
							</div>
							<div className='card-body'>
								<h4 className='card-title'>Lorem Ipsum</h4>
								<p className='card-text'>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Omnis maiores sed sunt,
									iusto consectetur a!
								</p>
							</div>
						</a>
					</div>
					<div className='col-md-3'>
						<a
							href='/category/subcategory/product'
							className='card'>
							<div className='card-img-top'>
								<img
									src='https://placehold.it/300'
									alt='placeholder'
								/>
							</div>
							<div className='card-body'>
								<h4 className='card-title'>Lorem Ipsum</h4>
								<p className='card-text'>
									Lorem ipsum dolor sit amet consectetur,
									adipisicing elit. Omnis maiores sed sunt,
									iusto consectetur a!
								</p>
							</div>
						</a>
					</div>
				</Section>
				<WageLabelModal closeModal={this.closeLabelModal} />
			</div>
		)
	}
}

export default Product
